import React from 'react';
import { Badge } from 'reactstrap';

import { GocardlessMandate } from '~direct-debits/models';

interface ComponentProps {
  row: { status: GocardlessMandate['status'] };
}

// Lookup-driven mandate status badge. The API enriches each mandate with
// `status: { tag, name, colour }` from `lookup_gocardless_mandate_statuses`,
// so the badge is fully data-driven — adding a new GoCardless status is a
// migration concern, not a UI change.
const MandateStatusBadge: React.FC<ComponentProps> = ({ row }) => {
  const { tag, name, colour } = row.status;
  // The API contract is "hex without leading #", but strip defensively so a
  // future API change (or a typo in the lookup seed) can't render `##abcdef`.
  const backgroundColor = `#${colour.replace(/^#/, '')}`;
  return (
    <Badge style={{ backgroundColor }} data-cy={`dd-mandate-matching-status-${tag}`}>
      {name}
    </Badge>
  );
};

export default MandateStatusBadge;
